import { FormattedMessage } from "react-intl";

const MultiRegionDataResidency = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPageTeam24.features.multiRegionDataResidency.content.body"
                    defaultMessage="Specify where your content and data are hosted."
                />
            </p>
        </div>
    );
};

export default MultiRegionDataResidency;
